import { lazy } from 'react';

export const AgentConfigScreen = lazy(
  () => import('screens/AgentConfigScreen'),
);

export const CustomAnalyticsDashboardScreen = lazy(
  () => import('screens/CustomAnalyticsDashboard'),
);

export const QSAnalyticsDashboardScreen = lazy(
  () => import('screens/QSAnalyticsDashboard'),
);

export const CustomMetricsScreen = lazy(() => import('screens/CustomMetrics'));

export const HomePageScreen = lazy(() => import('screens/HomePage'));

export const StandardDashboardScreen = lazy(
  () => import('screens/StandardDashboard'),
);

export const SafetyDashboardScreen = lazy(
  () => import('screens/SafetyDashboard'),
);

export const AssistantAnalysisScreen = lazy(
  () => import('screens/AssistantAnalysis'),
);

export const AssistantAnalysisDetailsScreen = lazy(
  () => import('screens/AssistantAnalysisDetails'),
);

export const CreateAnalysisTaskScreen = lazy(
  () => import('screens/CreateAnalysisConfiguration'),
);

export const CreateAnalysisScreen = lazy(
  () => import('screens/CreateAnalysis'),
);

export const CreatePerformanceOverTimeAnalysisScreen = lazy(
  () => import('screens/CreatePerformanceOverTimeAnalysis'),
);

export const PerformanceOverTimeAnalysisScreen = lazy(
  () => import('screens/PerformanceOverTimeAnalysisDashboard'),
);

export const AnalysisDashboardScreen = lazy(
  () => import('screens/AnalysisDashboard'),
);

export const SpeechRecognitionScreen = lazy(
  () => import('screens/SpeechRecognition'),
);

export const OverwriteRuleCreateOrUpdate = lazy(
  () => import('screens/OverwriteRuleCreateOrUpdate'),
);

export const ConversationReviewScreen = lazy(
  () => import('screens/ConversationReview'),
);
export const LatestConversationRedirectScreen = lazy(
  () => import('screens/LatestConversationRedirect'),
);
export const ConversationsScreen = lazy(() => import('screens/Conversations'));

export const AudioManagementScreen = lazy(
  () => import('screens/AudioManagement'),
);

export const SmartAnalystScreen = lazy(() => import('screens/SmartAnalyst'));

export const TestSuiteScreen = lazy(() => import('screens/TestSuite'));

export const TestCaseDetailScreen = lazy(() => import('screens/TestCase'));

export const TestSetScreen = lazy(() => import('screens/TestSet'));

export const RealTimeConfigFilesScreen = lazy(
  () => import('screens/RealTimeConfigFiles'),
);
export const RealTimeConfigFileScreen = lazy(
  () => import('screens/RealTimeConfigFile'),
);
export const RealTimeConfigFormScreen = lazy(
  () => import('screens/RealTimeConfigForm'),
);

export const DashboardsSettingsScreen = lazy(
  () => import('screens/DashboardsSettings'),
);

export const SourceHubScreen = lazy(() => import('screens/SourceHub'));
export const NumbersScreen = lazy(() => import('screens/Numbers'));

export const OpentableWorkspaceScreen = lazy(
  () => import('screens/OpenTableWorkspace'),
);

export const WidgetConfigurationScreen = lazy(
  () => import('screens/WidgetConfiguration'),
);

export const AggregatedDashboardScreen = lazy(
  () => import('screens/AggregatedDashboardScreen'),
);

export const AggregatedDashboardEditScreen = lazy(
  () => import('screens/AggregatedDashboardEditScreen'),
);
